module.exports = __webpack_public_path__ + "img/icon_footer_01.754d6a4d.svg";